import { render, staticRenderFns } from "./AdminTracks.vue?vue&type=template&id=50d60264&scoped=true"
import script from "./AdminTracks.vue?vue&type=script&lang=js"
export * from "./AdminTracks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d60264",
  null
  
)

export default component.exports